import React, { Component } from 'react';
import PropTypes from 'prop-types';
import onClickOutside from 'react-onclickoutside';
import Close from '../ui/Close';

class AdvancedFilter extends Component {
  static propTypes = {
    showFilter: PropTypes.bool.isRequired,
    applyFilter: PropTypes.func.isRequired,
    closeFilter: PropTypes.func.isRequired,
    clearFilter: PropTypes.func.isRequired,
    Layout: PropTypes.func.isRequired,
    handleChange: PropTypes.func.isRequired
  };

  handleClickOutside = () => this.props.closeFilter();

  _renderLayout = layoutProps => {
    const { Layout } = this.props;

    if (!Layout) {
      return null;
    }

    return <Layout {...layoutProps} />;
  };

  clearFilter = event => {
    event.preventDefault();
    this.props.clearFilter();
  };

  applyFilter = event => {
    event.preventDefault();
    this.props.applyFilter();
  };

  render () {
    const { showFilter, closeFilter, ...layoutProps } = this.props;

    return (
      <div className='filter'>
        <div className={`advanced-filter col-md-9 col-lg-7 col-xl-7 pl-0 pr-0 ${showFilter ? 'filter-opened' : ''}`}>
          <form className='advanced-filter-form' onSubmit={this.applyFilter}>
            <div className='list-group-item py-0 mb-3 d-flex'>
              <button
                type='button'
                className='clear-filters non-button mr-auto'
                onClick={this.clearFilter}
              >
                Clear filters
              </button>

              <Close onClick={closeFilter} />
            </div>
            <div className='list-group-item py-0'>
              {this._renderLayout(layoutProps)}

              <div className='row d-flex align-items-center'>
                <div className='col-12 offset-sm-3 col-sm-9'>
                  <button
                    className='button button-primary w-100'
                    type='submit'
                  >Apply</button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export default onClickOutside(AdvancedFilter);



// WEBPACK FOOTER //
// ./src/components/common/AdvancedFilter/index.js